import React, { useState } from "react";
import { Tabs, Tab, Box,  IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AllDoctorsList from "./AllDoctorsList"; // Doctor list component
import DoctorDetails from "./DoctorDetails"; // Doctor details component

const DoctorDetailsTabs = () => {
  const [tabs, setTabs] = useState([{ id: "list", label: "All Doctors", type: "list" }]);
  const [selectedTab, setSelectedTab] = useState("list");

  // Function to add a new doctor tab
  const handleAddTab = (doctor) => {
    const newTab = { id: doctor.id, label: doctor.fname + " " + doctor.lname, type: "details", doctor };
    
    // Avoid duplicate tabs
    if (!tabs.find((tab) => tab.id === doctor.id)) {
      setTabs((prevTabs) => [...prevTabs, newTab]);
    }
    setSelectedTab(doctor.id); // Switch to the newly opened tab
  };

  // Function to remove a tab
  const handleRemoveTab = (tabId) => {
    const newTabs = tabs.filter((tab) => tab.id !== tabId);
    setTabs(newTabs);
    
    // If the removed tab was selected, move to the previous tab
    if (selectedTab === tabId) {
      setSelectedTab(newTabs.length ? newTabs[newTabs.length - 1].id : "list");
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      {/* Tabs Navigation */}
      <Tabs value={selectedTab} onChange={(e, newValue) => setSelectedTab(newValue)} variant="scrollable">
        {tabs.map((tab) => (
          <Tab
            key={tab.id}
            value={tab.id}
            label={
              <Box display="flex" alignItems="center">
                {tab.label}
                {tab.type !== "list" && (
                  <IconButton size="small" onClick={() => handleRemoveTab(tab.id)}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
            }
          />
        ))}
      </Tabs>

      {/* Tab Content */}
      <Box p={2}>
        {tabs.map((tab) =>
          tab.id === selectedTab ? (
            tab.type === "list" ? (
              <AllDoctorsList key="doctor-list" onDoctorClick={handleAddTab} />
            ) : (
              <DoctorDetails key={tab.id} doctor={tab.doctor} />
            )
          ) : null
        )}
      </Box>
    </Box>
  );
};

export default DoctorDetailsTabs;
